if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const mediaId = this.openedBy?.getAttribute('data-media-id');
        const isProductPage = !!this.openedBy?.getAttribute('data-media-id');

        this.querySelectorAll(`[data-media-id]`).forEach((element, index) => {
          if (isProductPage) {
            element.classList.toggle('active', element.getAttribute('data-media-id') === mediaId);
          } else {
            element.classList.toggle('active', index === 0);
          }
        });

        if (!isProductPage) return;

        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate?.content;

        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        if (container && activeMedia?.width) {
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent?.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }
    }
  );
}
